export enum DelistTypes {
  ALL = 'all',
  NEW = 'new',
  USED = 'used',
}

export enum AnnouncementType {
  CREDIT700 = 'credit700',
  PODIUM = 'podium',
}
